import PageHead from 'src/components/page-head/page-head.component';
import {
  defaultPageHeader,
  getPageHeaderData,
  PageHeader,
} from 'src/utils/pageheader';
import {
  isPreviewMode,
  PageData,
  SSR_STATUS_CODES,
} from 'src/utils/ssr-helper';
import PageESIWrapper from 'src/components/page-esi-wrapper/page-esi-wrapper.component';
import PreviewBannerComponent from 'src/components/preview-banner/preview.banner-component';
import Help from 'src/components/faq/genesys-help';
import { getGenesysPath } from '.';
import { GetServerSidePropsContext } from 'next';

const helpPageHeader: PageHeader = {
  ...defaultPageHeader,
  title: 'Knowledge Portal',
  brandName: 'Virgin Atlantic',
  description: 'Virgin Atlantic - Knowledge Portal',
  canonicalUrl: 'https://virginatlantic.com/help',
};

export const getServerSideProps = async ({
  locale,
}: GetServerSidePropsContext) => {
  const pageData = {
    status: SSR_STATUS_CODES.SUCCESS,
    errorCode: 0,
    errorMessage: null,
    content: null,
    localeInfo: locale,
  };
  return {
    props: {
      ...pageData,
    },
  };
};

export default function HelpArticle({ localeInfo, pageHeader }: PageData) {
  return (
    <div>
      <PageHead {...helpPageHeader} />
      <PageESIWrapper localeInfo={localeInfo}>
        {isPreviewMode && <PreviewBannerComponent />}
        <div style={{ overflow: 'auto', overflowX: 'hidden' }}>
          <Help path={getGenesysPath(localeInfo)} />
        </div>
      </PageESIWrapper>
    </div>
  );
}
